module.exports = __webpack_public_path__ + "img/top.97a5a479.jpg";